import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Dashboard from './dashboard';
import './dashome.css';
import ClassDashboard from './groups/groupindividual.js';
import ClassGroups from './groups';
import Sidebar from './sidebar';
import QuickPayment from './groups/quickpayments.js';
import Transactionsfull from './groups/fulltranscations.js';
import MembersPage from './allmemberss.js';
import StaffPage from './staff.js';
import AttendancePagefull from './fullattendence.js';
import Cab from './groups/Cab.js';
import Expenses from './groups/Expenses.js';
import CabReport from './groups/CabReport.js';
import ExpensesReport from './groups/ExpenseReport.js';
import AttendanceReport from './groups/StudentAttendance.js';
// import AttendancePage from './groups/attendence.js';
import ProfileModal from './groups/Staffprofile.js';
import TeacherWelcome from "../components/groups/welcome.js";
import StaffAttendance from './groups/StaffAttendence.js';
import StudentDetail from "./groups/StudentDetail.js"
import MemberDetails from './MemberDetails.js';
function Dashome() {

  const user = JSON.parse(sessionStorage.getItem("user") || "{}");
const role = user.role;

  return (
    <div className="layout-container">
      <Sidebar />
      <div className="main-content">
        <Routes>
          {/* <Route path="/" element={<Dashboard />} /> */}
<Route
  path="/"
  element={role === "tstaff" ? <TeacherWelcome /> : <Dashboard />}
/>


          <Route path="/groups" element={<ClassGroups />} />
          <Route path="/member" element={<MembersPage />} />
          <Route path="/quick" element={<QuickPayment />} />
          {/* <Route path="/attendence" element={< AttendancePage/>}/> */}
          <Route path='/fullattend' element={ <AttendancePagefull/> } />
          <Route path='/cab'element={<Cab/>}/>
          <Route path='expenses'element={<Expenses/>}/>
          <Route path='reports/cab-report'element={<CabReport/>}/>
          <Route path='/reports/Student-Attendance'element={<AttendanceReport/>}/>
          <Route path='/reports/expense-Report' element={<ExpensesReport/>}/>
          <Route path="/group-details/:groupid/*" element={<ClassDashboard />} />
          <Route path="/transactions" element={<Transactionsfull />} />
          <Route path='/StaffAttendance' element={<StaffAttendance/>}/>
          <Route path="/staff" element={<StaffPage />} />
          <Route path="/student/:id" element={ <StudentDetail/> } />
              <Route path="/member-details" element={ <MemberDetails/>   } /> 
                 <Route path="/profile" element={ <ProfileModal/>  } />
        </Routes>
      </div>
    </div>
  );
}

export default Dashome;
